import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { BusinessRulesInterface } from '../../../../interfaces/business-rules.interface';
import { BusinessRulesService } from '../../../../services/business-rules.service';
import { BusinessRulesTypeEnum } from '../../../../enums/businessRulesTypes.enum';
import { BusinessRulesHelper } from '../../business-rules-helper';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-business-rules-length-rule-type',
  templateUrl: './business-rules-lengthRuleType.component.html',
  styleUrls: ['./business-rules-lengthRuleType.component.scss']
})
export class BusinessRulesLengthRuleTypeComponent implements OnChanges {
  @Input()
  businessRule: BusinessRulesInterface;
  @Input()
  type: BusinessRulesTypeEnum;
  @Output()
  isActivated = new EventEmitter<string>();
  public isActive = false;
  public numberFormValue: number;
  public ruleText = BusinessRulesHelper;
  isSubmitting = false;

  constructor(
    private toastr: ToastsManager,
    private businessRuleService: BusinessRulesService,
    public translate: TranslateService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const update = changes['businessRule'];
    if (update && update.currentValue) {
      switch (this.type) {
        case BusinessRulesTypeEnum.EOP_LENGTH:
          this.numberFormValue = update.currentValue.eopLength;
          this.isActive = update.currentValue.isActive;
          break;
        case BusinessRulesTypeEnum.MAX_WINBACK_INACTIVE_LENGTH:
          this.numberFormValue = update.currentValue.winbackStatusMaxDays;
          this.isActive = update.currentValue.isActive;
          break;
        case BusinessRulesTypeEnum.BLOCK_MIGRATION_ON_DISCOUNT_PERIOD_START:
          this.numberFormValue = update.currentValue.maxMigrationOfferPrice;
          this.isActive = update.currentValue.isActive;
      }
    }
  }

  getBusinessTypeRuleData(type): BusinessRulesInterface {
    switch (type) {
      case BusinessRulesTypeEnum.EOP_LENGTH:
        return {
          type: type,
          isActive: true,
          eopLength: this.numberFormValue
        };
      case BusinessRulesTypeEnum.MAX_WINBACK_INACTIVE_LENGTH:
        return {
          type: type,
          isActive: this.isActive,
          winbackStatusMaxDays: this.numberFormValue
        };
      case BusinessRulesTypeEnum.BLOCK_MIGRATION_ON_DISCOUNT_PERIOD_START:
        return {
          type: type,
          isActive: this.isActive,
          maxMigrationOfferPrice: this.numberFormValue
        };
    }
  }

  saveRule(): void {
    this.isSubmitting = true;

    if (!this.businessRule) {
      this.businessRuleService.create(this.getBusinessTypeRuleData(this.type)).subscribe(createdRule => {
        this.businessRule = createdRule;
        this.isSubmitting = false;
      });
      return;
    }
    this.businessRuleService.update(this.getBusinessTypeRuleData(this.type), this.businessRule._id).subscribe(
      businessRule => {
        this.businessRule = businessRule;
        this.isActivated.emit();
        this.isSubmitting = false;

        return this.toastr.success(this.translate.instant('BUSINESS_RULES_LENGTH_RULE_TYPE.COMPONENT.SUCCESS'));
      },
      () => {
        this.toastr.error(this.translate.instant('BUSINESS_RULES_LENGTH_RULE_TYPE.COMPONENT.ERROR'));
        this.isSubmitting = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/business-rules/business-rules-components/business-rules-lengthRuleType/business-rules-lengthRuleType.component.ts